import { Menu } from "@headlessui/react";
import React, { useEffect } from "react";
import { FaBirthdayCake } from "react-icons/fa";
import { notificationsData } from "./Datas";
import { BiCalendar } from "react-icons/bi";
import { useDispatch } from "react-redux";
import {
  deleteNewNotification,
  marcarLeidoHoy,
  cancelarNotification,
} from "../redux/features/notificationSlice";

// Etiqueta legible del modo de aviso, para que la doctora sepa si el recordatorio se repite.
const ETIQUETA_FRECUENCIA = {
  una_vez: "Una vez",
  dia_antes: "Un día antes",
  diaria: "Todos los días",
};

function NotificationComp({ children, notifications }) {
  const dispatch = useDispatch();

  const handleRead = () => {
    dispatch(deleteNewNotification())
  }
  return (
    <Menu>
      <Menu.Button>{children}</Menu.Button>
      <Menu.Items className="flex flex-col w-full sm:w-8/12 md:w-6/12  xl:w-2/6 top-20 right-0 gap-4 absolute bg-white rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none z-50">
        <div className="flex-btn flex-wrap gap-4">
          <h2 className="text-md font-medium text-main">Notificaciones</h2>
          <button className="px-4 py-2 hover:bg-text rounded-md text-subMain text-sm" onClick={handleRead}>
            Marcar como leidos
          </button>
        </div>
        {/* notif */}
        <div className="flex flex-col gap-4 overflow-y-scroll max-h-[500px]">
          {notifications?.map((item) => (
            !item.leido &&
            <div
              key={item.id}
              className="w-full p-4 border border-border rounded-lg"
            >
              <div className="grid xs:grid-cols-12 gap-4 items-center">
                <div className="xs:col-span-2">
                  <div
                    className={`${
                      item.action === 1
                        ? "bg-subMain text-white"
                        : "bg-text text-subMain"
                    }
                  w-12 h-12 rounded-full text-md flex-colo border-[.5px] border-subMain`}
                  >
                    {<BiCalendar />}
                  </div>
                </div>
                <div className="xs:col-span-10 ">
                  <p className="text-sm text-textGray">
                    {item.motivo}{" "}
                    {/* El paciente es opcional: los recordatorios generales no tienen uno */}
                    {item.patient?.persona && (
                      <span className="text-main font-medium">
                        {`${item.patient.persona.nombre ?? ""} ${
                          item.patient.persona.apellidos ?? ""
                        }`.trim()}
                      </span>
                    )}
                  </p>
                  <div className="flex items-center gap-3 mt-2">
                    {item.frecuencia && (
                      <span className="text-[11px] px-2 py-[2px] rounded-full bg-text text-subMain">
                        {ETIQUETA_FRECUENCIA[item.frecuencia] ?? item.frecuencia}
                      </span>
                    )}
                    <button
                      onClick={() => dispatch(marcarLeidoHoy(item.id))}
                      className="text-xs text-subMain hover:underline"
                    >
                      Leído por hoy
                    </button>
                    <button
                      onClick={() => dispatch(cancelarNotification(item.id))}
                      className="text-xs text-red-500 hover:underline"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  );
}

export default NotificationComp;
